import heading from '../../common/headings';
import { BaseComponent } from '../base-component/base-component';
import { CreateCustomProductSupplement } from './interfaces/create-custom-product.interface';
import { css, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('mhecomm-create-custom-product-supplements')
export class CreateCustomProductSupplementsView extends BaseComponent {
  static styles = [
    css`
      .header-text {
        font-size: 1.125rem;
      }
    `,
  ];

  @property()
  header = 'Included With Purchase';

  @property()
  headerLevel = 'h5';

  @property({ type: Boolean })
  showDivider = false;

  @property({ type: Array })
  supplements?: CreateCustomProductSupplement[];

  renderComp(): TemplateResult | typeof nothing {
    if (!this.supplements?.length) {
      return nothing;
    }

    return html`
      <div>
        ${heading(this.headerLevel, this.header, [`fw-bold header-text ${!this.showDivider ? 'mb-2' : ''}`])}
        ${this.showDivider ? html`<hr class="my-2" />` : nothing}
        <div id="product-supplements">
          ${this.getSupplements(this.supplements)}
        </div>
      </div>
    `;
  }

  /**
   * Returns a list of supplements to be rendered in the product card.
   *
   * @param supplements
   */
  private getSupplements(supplements: CreateCustomProductSupplement[]): TemplateResult {
    return html` <ul class="list-unstyled mb-0">
      ${supplements.map((supplement) => html` <li>${supplement.name}</li>`)}
    </ul>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-create-custom-product-supplements': CreateCustomProductSupplementsView;
  }
}
